/**
 * donseed.js
 * Vanilla JS fuer DonSeed Theme
 * Kein Framework benoetigt – Shopify liefert eigenes JS ueber Dawn base
 */

/* ── Hero Slideshow ──────────────────────────────────────────── */
class DonSeedSlideshow {
  constructor(el) {
    this.el       = el;
    this.slides   = Array.from(el.querySelectorAll('[data-slide]'));
    this.dots     = Array.from(el.querySelectorAll('[data-dot]'));
    this.current  = 0;
    this.autoplay = el.dataset.autoplay === 'true';
    this.speed    = (parseInt(el.dataset.speed, 10) || 5) * 1000;
    this.timer    = null;

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });

    if (this.autoplay && this.slides.length > 1) this.startTimer();
  }

  goTo(index) {
    this.slides[this.current].classList.remove('is-active');
    this.dots[this.current]?.classList.remove('is-active');
    this.current = (index + this.slides.length) % this.slides.length;
    this.slides[this.current].classList.add('is-active');
    this.dots[this.current]?.classList.add('is-active');
  }

  next() { this.goTo(this.current + 1); }

  startTimer() {
    this.timer = setInterval(() => this.next(), this.speed);
    // Pause on hover
    this.el.addEventListener('mouseenter', () => clearInterval(this.timer));
    this.el.addEventListener('mouseleave', () => this.startTimer());
  }
}

// Init alle Slideshows auf der Seite
document.querySelectorAll('[data-slideshow]').forEach(el => {
  new DonSeedSlideshow(el);
});


/* ── Sticky Header Scroll Shadow ────────────────────────────── */
const header = document.querySelector('.header-wrapper');
if (header) {
  const onScroll = () => {
    header.style.boxShadow = window.scrollY > 10
      ? '0 2px 20px rgba(0,0,0,0.5)'
      : 'none';
  };
  window.addEventListener('scroll', onScroll, { passive: true });
}


/* ── Mobile Nav Toggle ───────────────────────────────────────── */
// Wird spaeter ergaenzt wenn Mobile Menu Sektion gebaut wird


/* ── Utility: Format Money ───────────────────────────────────── */
// In Liquid wird {{ price | money }} genutzt – kein JS noetig
// Fuer zukuenftige AJAX-Cart-Updates:
function formatMoney(cents) {
  return new Intl.NumberFormat('de-DE', {
    style:    'currency',
    currency: 'EUR',
  }).format(cents / 100);
}


/* ── AJAX Add-to-Cart (Vorbereitung fuer spaetere Features) ─── */
async function addToCart(variantId, quantity = 1) {
  const response = await fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity }),
  });
  if (!response.ok) throw new Error('Add to cart failed');
  const item = await response.json();
  updateCartCount();
  return item;
}

async function updateCartCount() {
  const response = await fetch('/cart.js');
  const cart     = await response.json();
  const bubble   = document.querySelector('.cart-count-bubble');
  if (bubble) {
    bubble.textContent  = cart.item_count;
    bubble.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
  }
}


/* ── Quick-Add auf Produkt-Cards ─────────────────────────────── */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-quick-add]');
  if (!button) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = button.dataset.variantId;
  if (!variantId || button.disabled) return;

  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = 'Wird hinzugefügt…';

  try {
    await addToCart(variantId, 1);
    button.textContent = '✓ Hinzugefügt';
    button.classList.add('is-added');
    setTimeout(() => {
      button.textContent = originalLabel;
      button.classList.remove('is-added');
      button.disabled = false;
    }, 1800);
  } catch (error) {
    button.textContent = 'Fehler – erneut versuchen';
    button.disabled = false;
  }
});
